<template>
  <v-row justify="center">
    <v-col cols="12" class="pa-0">
      <v-toolbar color="primary" height="48" dark class="elevation-0">
        <v-toolbar-title class="subheading">基本情報</v-toolbar-title>
          <v-switch
            v-if="getPrivilegesLevel(data) == 0"
            v-model="tempUser.enable"
            :label="tempUser.enable ? '有効' : '無効'"
            hide-details
            class="px-4"
            @change="onValueChange()"
          ></v-switch>
        <v-spacer></v-spacer>
        <v-btn :disabled="!change" color="error" rounded depressed @click.stop.prevent="onStoreDialog()">
          {{ tempUser.key != null ? '更新' : '登録' }}
        </v-btn>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card flat tile>
        <v-card-text class="py-0">
          <v-row >
            <v-col v-if="checkIconViewable()" cols="2">
              <v-row class="ma-0 pa-0" align="center" justify="center">
                <v-col cols="12" class="py-0">
                  <v-avatar-selector
                    v-model="file"
                    :previewSize="80"
                    :tile="false"
                    :url="getProfileImage()"
                    :enable="true"
                    :icon="'mdi-image-plus'"
                  >
                  </v-avatar-selector>
                </v-col>
                <v-col cols="12" class="py-0 ml-1">
                  <v-btn dark rounded depressed x-small color="error" @click="onAvatarReset()">
                    <span class="text-none">初期化</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="py-0">
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    ref="sei"
                    label="姓（漢字）"
                    v-model="tempUser.sei"
                    @change="onValueChange()"
                    :disabled="type == 'view'"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    ref="mei"
                    label="名（漢字）"
                    v-model="tempUser.mei"
                    @change="onValueChange()"
                    :disabled="type == 'view'"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    ref="seiY"
                    label="*姓（ふりがな）"
                    v-model="tempUser.seiY"
                    :rules="[rules.required]"
                    :background-color="tempUser.seiY ? '' : 'green lighten-5'"
                    @change="onValueChange()"
                    :disabled="type == 'view'"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    ref="meiY"
                    label="*名（ふりがな）"
                    v-model="tempUser.meiY"
                    :rules="[rules.required]"
                    :background-color="tempUser.meiY ? '' : 'green lighten-5'"
                    @change="onValueChange()"
                    :disabled="type == 'view'"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-select
                    :items="$GENDERS"
                    label="性別"
                    v-model="tempUser.gender"
                    @change="onValueChange()"
                    item-value="key"
                    item-text="name"
                    :disabled="type == 'view'"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-row>
                    <v-combobox
                      ref="scholae"
                      prepend-icon="mdi-school"
                      :items="scholae"
                      label="学校"
                      v-model="tempScholae"
                      class="mr-1"
                      dense
                      hide-details
                      item-text="name"
                      item-value="key"
                      append-outer-icon="mdi-plus"
                      @click:append-outer="onAddScholae()"
                      @change="onValueChangeValidate()"
                      :disabled="type == 'view'"
                      >
                    </v-combobox>
                  </v-row>
                </v-col>
                <v-col cols="3" class="py-0">
                    <v-select
                      ref="grade"
                      :items="$GRADES"
                      label="*学年"
                      v-model="grade"
                      dense
                      item-text="name"
                      item-value="key"
                      class="mr-1"
                      :rules="checkGrade"
                      :background-color="grade ? '' : 'green lighten-5'"
                      @change="isGradeChange = true, onValueChange()"
                      :disabled="type == 'view'"
                    >
                    </v-select>
                </v-col>
                <v-col cols="3" class="py-0" align="center">
                  <template-date-picker
                    :id="1"
                    :icon="'event'"
                    :date="tempUser.birth"
                    :label="'生年月日'"
                    :title="false"
                    :hideDetails="true"
                    :dense="true"
                    @updated="onUpdated"
                    :disabled="type == 'view'"
                  ></template-date-picker>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="py-0"></v-col>
            <v-col cols="5" class="py-0">
              <v-select
                v-if="tempUser.status > 1"
                :items="tempGroups"
                label="教室"
                v-model="group"
                dense
                item-text="name"
                item-value="key"
                class="mr-1"
                @change="onValueChange()"
                :disabled="type == 'view'"
              ></v-select>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-select
                :items="myUsers"
                label="担当"
                v-model="tempUser.charge"
                dense
                item-text="name"
                item-value="key"
                @change="onValueChange()"
                :disabled="type == 'view'"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <template v-if="checkAccess()">
      <v-col cols="12" class="pa-0">
        <v-toolbar height="40" class="elevation-0 b-B">
          <v-toolbar-title class="subheading">連絡先</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon color="transparent" class="elevation-0" :disabled="type == 'view'" @click.native="onContactAdd()">
            <v-icon color="primary">add</v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-card flat tile>
          <v-card-text class="pa-0">
            <v-list>
              <v-list-item
                v-for="(item, index) in tempUser.contacts"
                :key="index"
                @click.stop="onEditContact(item)"
                :disabled="type == 'view'"
              >
                <v-col cols="12" class="py-0">
                  <v-row align="center" justify="center">
                    <v-col cols="1" class="pa-0">
                      <v-icon>{{ item.type == 1 ? 'person' : 'mdi-shield-account' }}</v-icon>
                    </v-col>
                    <v-col cols="5" class="pa-0">
                      <v-row v-if="item.type == 1">
                        <v-col cols="12" class="pa-0">
                          <span class="pr-2 subtitle-1">{{ item.zip }}</span>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <span class="subtitle-1">{{ item.address }}</span>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="12" class="pa-0">
                          <span class="pr-2 subtitle-1">{{ item.sei }}</span><span>{{ item.mei }}</span><span>{{ '（' + item.seiY + ' ' + item.meiY + '）' }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="5" class="pa-0">
                      <v-row>
                        <v-col cols="6" class="pa-0">
                          <v-icon size="18">mdi-cellphone</v-icon>
                          <span class="pl-1 subtitle-1">{{ item.mobile }}</span>
                        </v-col>
                        <v-col cols="6" class="pa-0">
                          <template v-if="item.available2">
                            <span class="pl-1 subtitle-1">{{ item.available2.from }}</span>
                            <v-icon v-if="item.available2.from" size="18" class="pl-1">mdi-minus</v-icon>
                            <span class="pl-1 subtitle-1">{{ item.available2.to }}</span>
                            <v-icon v-if="item.available2.from" size="20" :color="item.available2.flag ? 'primary' : 'error'" class="pl-1">{{ item.available2.flag ? 'mdi-circle-double' : 'mdi-close-circle-outline' }}</v-icon>
                          </template>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" class="pa-0">
                          <v-icon size="18">mdi-phone-classic</v-icon>
                          <span class="pl-1 subtitle-1">{{ item.phone }}</span>
                        </v-col>
                        <v-col cols="6" class="pa-0">
                          <template v-if="item.available1">
                            <span class="pl-1 subtitle-1">{{ item.available1.from }}</span>
                            <v-icon v-if="item.available1.from" size="18" class="pl-1">mdi-minus</v-icon>
                            <span class="pl-1 subtitle-1">{{ item.available1.to }}</span>
                            <v-icon v-if="item.available1.from" size="20" :color="item.available1.flag ? 'primary' : 'error'" class="pl-1">{{ item.available1.flag ? 'mdi-circle-double' : 'mdi-close-circle-outline' }}</v-icon>
                          </template>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="1" class="pa-0">
                      <v-row justify="end">
                        <v-tooltip v-if="item.memo" bottom color="transparent">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" size="20" color="primary">mdi-pencil-box</v-icon>
                          </template>
                          <v-card class="pa-0" width="200">
                            <v-card-text class="pa-1">
                              <span>{{ item.memo }}</span>
                            </v-card-text>
                          </v-card>
                        </v-tooltip>
                        <v-btn icon small :disabled="type == 'view'" @click.stop="onDeleteDialog(item)" color="transparent" class="elevation-0"><v-icon color="error">delete</v-icon></v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </template>
    <v-col cols="12" class="pa-0">
      <v-toolbar height="40" class="elevation-0 b-B">
        <v-toolbar-title class="subheading">個性</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon color="transparent" class="elevation-0" :disabled="type == 'view'" @click.native="onAddCharacter()">
          <v-icon color="primary">add</v-icon>
        </v-btn>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card flat tile>
        <v-card-text>
          <v-row justify="center">
            <template v-for='(item, index) in tempUser.characteristics'>
              <template v-if="type == 'edit'">
                <v-chip v-if="item.done" flat :color="$PERSONALITY_COLORS[item.type]" text-color="white" close class="caption ma-1" :key='index' @click:close="item.done = false, onDeleteCharacter()">
                  <v-avatar>
                    <v-icon class="pr-1">{{ $PERSONALITY_ICONS[item.type] }}</v-icon>
                  </v-avatar>
                  <span>{{ item.comment }}</span>
                </v-chip>
              </template>
              <template v-else>
                <v-chip v-if="item.done" flat :color="$PERSONALITY_COLORS[item.type]" text-color="white" class="caption ma-1" :key='index'>
                  <v-avatar>
                    <v-icon class="pr-1">{{ $PERSONALITY_ICONS[item.type] }}</v-icon>
                  </v-avatar>
                  <span>{{ item.comment }}</span>
                </v-chip>
              </template>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='contactDialog'
          persistent
          max-width="400px">
          <app-contact-dialog
            v-if="contactDialog"
            @dismissed="onDismissed"
            :item="contact"
            :user="tempUser"
            :dialog='contactDialog'>
          </app-contact-dialog>
        </v-dialog>
      </v-layout>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='character'
          persistent
          max-width="400px">
          <app-character-dialog
            v-if="character"
            @dismissed="onDismissed"
            :item="contact"
            :dialog='character'>
          </app-character-dialog>
        </v-dialog>
      </v-layout>
    </div>

    <div>
      <v-dialog v-model="addDialog"
        persistent
        max-width="400"
        >
        <template-scholae-dialog
          v-if="addDialog"
          @dismissed="onDismissed"
          :dialog='addDialog'
          :item="null"
          :type="'edit'"
        >
        </template-scholae-dialog>
      </v-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='更新'
        message='生徒情報を更新します。保存（登録）していない対応情報は消えますが、よろしいですか?'
        :dialog='storeDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='削除'
        message='連絡先を削除します。よろしいですか?'
        :dialog='deleteDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Contact from './ContactDialog.vue'
import Character from './CharacterDialog.vue'
import TemplateScholaeDialog from '../user/TemplateScholaeDialog.vue'
import DatePicker from '../common/TemplateDate.vue'
Vue.component('template-scholae-dialog', TemplateScholaeDialog)
Vue.component('app-contact-dialog', Contact)
Vue.component('app-character-dialog', Character)
Vue.component('template-date-picker', DatePicker)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scholae: 'scholae/scholae',
      students: 'students/students'
    }),
    form () {
      return {
        seiY: this.tempUser.seiY,
        meiY: this.tempUser.meiY,
        grade: this.grade
      }
    },
    myUsers () {
      var temp = []
      if (typeof this.item.groups === 'undefined') {
        return temp
      }
      var key = this.group
      for (var i in this.users) {
        if (key === null && this.getPrivilegesLevel(this.users[i]) <= 2) {
          temp.push(JSON.parse(JSON.stringify(this.users[i])))
        } else if (this.users[i].groups[key]) {
          temp.push(JSON.parse(JSON.stringify(this.users[i])))
        }
      }
      return temp
    }
  },
  watch: {
    groups () {
      this.createGroups()
    },
    file () {
      this.onValueChange()
    },
    item () {
      this.init()
    }
  },
  data () {
    return {
      file: null,
      rules: {
        required: value => !!value || '必須'
      },
      checkGrade: [
        v => v !== null || '必須',
        v => /^[0-9]|1[0-3]/.test(v) || '必須'
      ],
      myEvents: [],
      event: null,
      loading: false,
      character: false,
      storeDialog: false,
      deleteDialog: false,
      contactDialog: false,
      addDialog: false,
      formHasErrors: false,
      tempGroups: [],
      group: null,
      tempUser: null,
      contact: null,
      remove: null,
      grade: null,
      isGradeChange: false,
      change: false,
      tempScholae: null
    }
  },
  props: [ 'item', 'dialog', 'type', 'check' ],
  created () {
    this.init()
  },
  methods: {
    init () {
      this.tempUser = JSON.parse(JSON.stringify(this.item))
      var index = this.scholae.findIndex(s => s.key === this.tempUser.school)
      if (index !== -1) {
        this.tempScholae = this.scholae[index]
      }
      this.createGroups()
      this.grade = this.getGrade(this.tempUser)
    },
    createGroups () {
      this.tempGroups = []
      if (!this.data) {
        return
      }
      if (this.checkPrimary()) {
        if (this.data.order) {
          for (var i in this.data.order) {
            var index = this.groups.findIndex(group => group.key === this.data.order[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        } else {
          var keys = Object.keys(this.data.groups)
          for (i in keys) {
            if (this.data.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
      } else {
        var school = this.getPrimary()
        if (school !== null) {
          keys = Object.keys(school.groups)
          for (i in keys) {
            if (school.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
      }
      keys = Object.keys(this.tempUser.groups)
      for (i in keys) {
        if (this.tempUser.groups[keys[i]]) {
          this.group = keys[i]
        }
      }
    },
    getProfileImage () {
      if (this.tempUser) {
        if (this.tempUser.avatar) {
          return this.tempUser.avatar.thumbnail
        }
      }
      return ''
    },
    checkAccess () {
      if (typeof this.data.accessContact === 'undefined') {
        if (this.getPrivilegesLevel(this.data) < 3) {
          return true
        }
        return false
      }
      return this.data.accessContact
    },
    checkIconViewable () {
      var keys = Object.keys(this.data.schools)
      for (var i in keys) {
        if (this.data.schools[keys[i]]) {
          var index = this.schools.findIndex(school => school.key === keys[i])
          if (index !== -1) {
            return this.schools[index].studentsIcon
          }
        }
      }
      return false
    },
    onUpdated: function (value) {
      switch (value.id) {
        case 1:
          this.tempUser.birth = value.date
          this.onChange()
          break
      }
    },
    onValueChange () {
      this.change = true
    },
    onValueChangeValidate () {
      if (!this.tempScholae) {
        return
      }
      if (typeof this.tempScholae.key === 'undefined') {
        return
      }
      if (this.tempScholae.key !== this.tempUser.school) {
        this.change = true
      }
    },
    onAddScholae () {
      this.addDialog = true
    },
    onChange () {
      this.onValueChange()
      this.grade = this.getGrade(this.tempUser)
    },
    onContactAdd () {
      this.contact = JSON.parse(JSON.stringify(this.$store.getters['students/contact']))
      this.contactDialog = true
    },
    onAddCharacter () {
      this.character = true
    },
    onDeleteCharacter () {
      if (this.tempUser.key) {
        var characteristics = []
        for (var i in this.tempUser.characteristics) {
          if (this.tempUser.characteristics[i].done) {
            characteristics.push(JSON.parse(JSON.stringify(this.tempUser.characteristics[i])))
          }
        }
        this.tempUser.characteristics = characteristics
        this.onStore()
      }
    },
    onEditContact (item) {
      this.contact = JSON.parse(JSON.stringify(item))
      this.contactDialog = true
    },
    onDeleteDialog (item) {
      this.remove = item
      this.deleteDialog = true
    },
    onRemove () {
      var index = this.tempUser.contacts.findIndex(contact => contact.id === this.remove.id)
      if (index !== -1) {
        this.tempUser.contacts.splice(index, 1)
        if (this.tempUser.key) {
          this.onStore()
        }
      }
    },
    onStoreDialog () {
      this.storeDialog = true
    },
    onStore () {
      var vm = this
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (this.form[f] === null) {
          this.formHasErrors = true
        }
        this.$refs[f].validate(true)
      })
      if (!this.formHasErrors) {
        this.loading = true
        this.storeDialog = false
        var payload = JSON.parse(JSON.stringify(this.$store.getters['students/initial']))
        var keys = Object.keys(payload)
        for (var i in keys) {
          payload[keys[i]] = this.tempUser[keys[i]]
        }
        if (this.isGradeChange) {
          payload.grade = this.grade
        }
        if (this.tempScholae && typeof this.tempScholae.key !== 'undefined' && this.tempScholae.key !== this.tempUser.school) {
          payload.school = this.tempScholae.key
        }
        if (this.group) {
          payload.groups = {}
          payload.groups[this.group] = true
        }
        if (payload.key === null) {
          payload['createdAt'] = parseInt(new Date().getTime())
        }
        payload['updatedAt'] = parseInt(new Date().getTime())
        this.$store.dispatch('students/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          if (resp !== null) {
            vm.tempUser = resp
            if (vm.file) {
              vm.$store.dispatch('storage/write', { blob: vm.file, child: 'students', id: resp.key, uuid: this.genUUIDv4() }).then(() => {
                vm.loading = false
                vm.change = false
                vm.$emit('updated', resp)
              })
            } else {
              vm.loading = false
              vm.change = false
              vm.$emit('updated', resp)
            }
          } else {
            vm.loading = false
            vm.change = false
            vm.$emit('updated', resp)
          }
        })
      }
    },
    onAvatarReset () {
      this.file = null
      this.tempUser.avatar = null
      this.onValueChange()
    },
    onDismissed: function (value) {
      if (this.storeDialog) {
        if (value) {
          this.onStore()
        }
        this.storeDialog = false
        return
      }
      if (this.deleteDialog) {
        if (value) {
          this.onRemove()
        }
        this.deleteDialog = false
        return
      }
      if (this.addDialog) {
        this.addDialog = false
        return
      }
      if (this.contactDialog) {
        if (value.item !== null) {
          var index = this.tempUser.contacts.findIndex(contact => contact.id === value.item.id)
          if (index !== -1) {
            Vue.set(this.tempUser.contacts, index, value.item)
          } else {
            value.item.id = this.tempUser.contacts.length + 1
            this.tempUser.contacts.push(value.item)
          }
          if (this.tempUser.key) {
            this.onStore()
          }
        }
        this.contactDialog = false
        return
      }
      if (this.character) {
        if (value) {
          this.tempUser.characteristics.push(value)
          if (this.tempUser.key) {
            this.onStore()
          }
        }
        this.character = false
      }
    }
  }
}
</script>

<style scoped>
.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.select-none {
  user-select: none;
}
</style>
